import styled from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import { backDropFilter } from "../../../styles/style-guide";
import { Button } from "../../utils/styles/Utils";

export const Section = styled.section`
  ${tw`py-20 px-0`};
`;

export const Item = styled.div`
  ${tw`m-0 mx-3.5 mb-8`};
  width: calc((100% / 3) - 30px);

  ${media.desktop} {
    margin: 0 30px 32px;
    width: calc(50% - 60px);
  }

  ${media.tablet} {
    margin: 0 min(34px, 10%) 32px;
    text-align: center;
    width: calc(100% - 30px);
  }
`;

export const Thumbnail = styled.div`
  ${tw`p-2.5 bg-white25 border border-solid border-white40`};
`;

export const Image = styled.img`
  ${tw`w-full rounded-lg`};
`;

export const Title = styled.h3`
  ${tw`text-xl capitalize my-5 mx-0`};
`;

export const Details = styled.div``;

export const Content = styled.div<{ open: boolean }>`
  ${tw`bg-white25 p-8 max-w-4xl w-full border border-solid border-white40 opacity-0`};
  backdrop-filter: ${backDropFilter};
  border-radius: 30px;
  transform: scale(0.5);

  ${({ open }) =>
    open &&
    `
    opacity: 1;
    transform: scale(1);
  `}

  ${media.tablet} {
    padding: 1.5rem;
  }
`;

export const Btn = styled.button`
  ${Button}
  font-family: inherit;
  text-transform: capitalize;
`;

export const Overlay = styled.div`
  ${tw`fixed left-0 top-0 h-full w-full z-50 overflow-y-auto`};
`;

export const Inner = styled.div`
  ${tw`min-h-screen py-10 px-3.5 flex items-center justify-center`};
`;

export const Header = styled.div`
  ${tw`relative`};
`;

export const ThumbnailPopUp = styled.div``;

export const Close = styled.button`
  ${Button};
  ${tw`h-10 w-10 p-0 flex items-center justify-center absolute`};
  top: -43px;
  right: -54px;
`;

export const Img = styled.img`
  ${tw`rounded-xl`};
`;

export const TitlePopUp = styled.h3`
  ${tw`text-2xl capitalize m-0 mt-5 mb-4`};

  ${media.tablet} {
    font-size: 20px;
  }
`;
